<!--
 * @Author: ai
 * @Date: 2023-08-28 11:04:25
 * @LastEditors: ai
 * @LastEditTime: 2024-01-03 16:01:53
 * @Description:
-->
<template>
  <div id="toast" :class="[isActive ? 'active' : '', type]">
    {{ message }}
  </div>
</template>

<script>
export default {
  name: "Toast-tip",
  data() {
    return {
      message: "", //传递的消息
      isActive: false, //是否处于活跃状态（显示在页面内）
      type: "", //消息样式
      timer1: null,
      timer2: null,
    };
  },
  mounted() {
    console.log("toast");
    this.$nextTick(() => {
      this.isActive = true;
    });
    this.timer1 = setTimeout(() => {
      this.isActive = false;
    }, this.delayer);
    this.timer2 = setTimeout(() => {
      this.$destroy(true); //销毁vue实例
    }, this.delayer * 2);
  },
  destroyed() {
    this.$el.parentNode.removeChild(this.$el); //移除dom元素
    clearTimeout(this.timer1);
    clearTimeout(this.timer2);
  },
};
</script>

<style scoped>
#toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px 30px;
  border-radius: 15px;
  z-index: 999;
  opacity: 0;
  transition: all 1s;
  text-align: center;
  font-size: 38px;
  white-space: nowrap;
}
#toast.success {
  background-color: #f0f9eb;
  color: #67c23a;
}
#toast.error {
  background-color: #fef0f0;
  color: #f56c6c;
}
#toast.active {
  /* top: 30px; */
  opacity: 1;
}
#toast.sign-error {
  transform: rotate(90deg);
  top: 50%;
  background-color: #fef0f0;
  color: #f56c6c;
}
#toast.sign-pc-error {
  top: 50%;
  background-color: #fef0f0;
  color: #f56c6c;
}
</style>
